import React, { useMemo } from "react"
import {
  faChevronRight,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { 
  setCurrentPartyDaysRange,
} from "../../../state/outstandingReceivableSlice.jsx"
import { useFetchWithBody } from "../../../api/reactQueryCustomHooks.jsx"
import { apiRoute, linksUrl, outTypeEnum } from "../../../constants/enum.js"
import { calculateTotal, pivotData } from "../../../Utility/utility.js" 
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../../components/index.js" 
import { COLUMN_ALIGN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../../components/NextUITable.jsx"

const OutRPartyAgeSummary = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { compCode } = useSelector((state) => state.company)
  const { currentParty } = useSelector(
    (state) => state.outstandingReceivable
  ) 

    const { isLoading, isError, data=[] } = useFetchWithBody({
      url: apiRoute.outstanding.partyAgingSummary,
      queryKey: "OutstandingReceivablePartyAgeSummary"+currentParty.id,
      manipulateData: true,
      manipulateDataFn: (newData) => {
        return pivotData({ data: [newData[0]] })
      },
      inputData: {
        compcode: compCode.join(","),
        party_id: currentParty.id,
        out_type: outTypeEnum.R,
      },
    })


  const totalpartyAgeSummary = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "daysRemaning",
      }),
    [data]
  )

  let downloadDataFooter = {
    daysRange: "",
    daysRemaning: "Total: " + totalpartyAgeSummary,
  }

  // const columns = useMemo(() => ["daysRange", "daysRemaning"], [])

  const exportColumns = [
    {
      uid: "daysRange",
      name: "Days Range",
    },
    {
      uid: "daysRemaning",
      name: "Aging",
    },
  ]

  
  const handleFooterNext = () => {
    dispatch(setCurrentPartyDaysRange({ daysRange: "All" }))
    navigate(linksUrl.outstanding.receivable.partyDetail)
  }

    const handleClickPrev = () => {
      navigate(linksUrl.outstanding.receivable.partySummary)
    }
  
  const INITIAL_VISIBLE_COLUMNS = ["daysRange", "actions"]

  const columns = [
    {
      uid: "daysRange",
      name: "Aging",
      secondCol: {
        name: "daysRemaning",
        icon: <FontAwesomeIcon icon={faIndianRupeeSign} size="sm" />,
      },
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalpartyAgeSummary,
      },
    },
    {
      name: "Days Remaning",
      uid: "daysRemaning",
    },
    {
      name: "ACTIONS",
      uid: "actions",
     // align:COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.link,
        label: "next",
        icon: <FontAwesomeIcon icon={faChevronRight} />,
        onClick: handleFooterNext,
      },
    },
  ]

  
  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faChevronRight} />,
      onClick: (row) => {
        dispatch(setCurrentPartyDaysRange(row))
        navigate(linksUrl.outstanding.receivable.partyDetail)
      },
      type:  ROW_ACTION_BTN_TYPE.link,
      label: "next",
    },
  ]

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <MainContainer
      pageName="Party Aging Summary"
      info={[["Party", currentParty.name]]}
      breadcrumbs={["Receivable", "Party Aging Summary"]}
      prevPage={{
        show: true,
        onClick: handleClickPrev,
      }}
    >
      <NextUITable
        INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
        data={data}
        columns={columns}
        exportColumns={exportColumns}
        rowActionBtn={rowActionBtn}
        downloadDataFooter={downloadDataFooter}
        showAdvanceFilter={false}
        downloadFileName="Receivable_Outstanding_Summary"
        id="party_id"
      />
    </MainContainer>
  )
}

export default OutRPartyAgeSummary
